/**
 * @description componente para mostrar mensajes de error en campos de un formulario
 */
import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-error',
  standalone: false,
  template: `
    <div class="validation-errors" *ngIf="control">
      <ng-container *ngFor="let validation of validationMessages">
        <div class="error-message" *ngIf="control.hasError(validation.type) && (control.dirty || control.touched)">
          <ion-icon name="information-circle-outline"></ion-icon> {{ validation.message }}
        </div>
      </ng-container>

      <div *ngIf="control?.errors?.['fechaFutura']" class="error-message">
        <ion-text color="danger">La fecha no puede ser mayor al día actual</ion-text>
      </div>

      <div *ngIf="control?.errors?.['fechaPasada']" class="error-message">
        <ion-text color="danger">La fecha debe ser igual o mayor al día actual</ion-text>
      </div>
    </div>
  `
})
export class FormErrorComponent {
  @Input() control: AbstractControl | null = null;
  @Input() validationMessages: any[] = [];
}
